// extracted by mini-css-extract-plugin
export var grid = "FAQ-module--grid--094e2";
export var root = "FAQ-module--root--29746";
export var title = "FAQ-module--title--f7db6";